import { CircleNotifications, Email, LinkOff, SettingsSuggest, ThumbDown, ThumbUp, Upgrade, Visibility } from "@mui/icons-material"
import { AppEventItemScheme } from "../../../../../backend/src/routes/schemes"
import { EventName, EventSeverity, HistoryLogEntityType } from "../../../../../backend/src/types"
import { AppEvent } from "../types"
import { AppAdminRoutes } from "@/config/routes"
import dayjs from "dayjs"
import { COLORS } from "@/themes/types"

export const ApiAppEventItemSchemeToEventMapper = (event: AppEventItemScheme): AppEvent => {
    const getIcon = () => {
        switch (event.eventName) {
            case EventName.INVOICE_AUTO_EXTRACT:
                return SettingsSuggest
            case EventName.PAYMENT_REQUEST_APPROVER_ASSIGNED:
                return Visibility
            case EventName.PAYMENT_REQUEST_APPROVED:
                return ThumbUp
            case EventName.PAYMENT_REQUEST_DENIED:
                return ThumbDown
            case EventName.INVOICE_CREATED_FROM_EMAIL:
                return Email
            case EventName.INVOICE_NOT_ASSIGNED:
                return LinkOff
            case EventName.VERSIONUPDATE:
                return Upgrade
            default:
                return CircleNotifications
        }
    }

    const getHref = () => {
        switch (event.entityType) {
            case HistoryLogEntityType.INVOICE:
                return AppAdminRoutes.invoices.children.detail.getLink(Number(event.entityId))
            case HistoryLogEntityType.PAYMENT_REQUEST:
                return AppAdminRoutes.paymentRequest.children.edit.getLink(Number(event.entityId))
            case HistoryLogEntityType.SYSTEM:
                return AppAdminRoutes.system.version.getLink(event.entityId)
            default:
                return undefined
        }
    }

    const getColor = (): COLORS | "default" => {
        switch (event.severity) {
            case EventSeverity.WARNING:
                return "warning.light"
            case EventSeverity.ERROR:
                return "error.light"
            case EventSeverity.SUCCESS:
                return "success.light"
            default:
                return "default"
        }
    }

    return {
        ...event,
        name: event.eventName,
        icon: getIcon(),
        href: getHref(),
        color: getColor(),
        readAt: event.readAt ? dayjs(event.readAt) : undefined,
        createdAt: dayjs(event.createdAt),
    }
}
